<template>
  <section class="p-networkmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">网络流量</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">MonitorWay网络流量分析平台系统，通过自动采集网络中传输的数据包，提炼加工出网络和应用性能类的指标数据。
            不仅具备数据回溯、定位故障、告警、分析报告等基础NPM功能；同时支持主动拨测、接入日志类数据并实现数据关联。以数据库的方式存储各类统计数据，提供灵活的数据消费手段。
            内置可自定义配置的Dashboard、简单灵活的数据表格、以及开放的数据对接功能，能够将MonitorWay网络流量分析平台中的任何指标或事件通过内置的消息队列功能传输到第三方平台，
            配合开放的Restful API为第三方提供数据，实现为用户量身定做的大数据自服务平台。从而做到降低运维复杂度，提升业务系统可靠性。
          </p>
          <img src="../../assets/monitor/network.svg" class="c-cs-p" preview="monitor-virtual"/>
        </section>
        <!-- <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 虚拟化监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-128 c-p-r">
            <ul>
              <li>快速发现虚拟机资产</li>
              <li>智能的优化服务器性能和部署的建议</li>
              <li>使用实时仪表板轻松确定性能、容量和配置问题并进行故障排除</li>
              <li>使用基准阈值对群集、主机、虚拟机和数据存储中的性能差异进行报警</li>
            </ul>
            <img src="../../assets/monitor/virtual-pic.png" class="c-pr-40 pic">
          </div>
        </section> -->
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/network1.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">多源数据整合</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">支持网络流量、设备日志、应用日志、NetFlow、NetStream、sFlow数据的接入处理，为智能分析、应用画像提供丰富的元数据。也可以对接CMDB，应用性能管理（APM），自动化等运维管理平台，搭建运维数据中台。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/network2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">故障快速定位</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">结合多种AI算法计算出的智能基线结合智能分析产品可以快速的进行故障的根因诊断，评估流量趋势、确定性能瓶颈。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/network3.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">灵活的自定义配置界面</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">除了内置的上百种大屏视图，也可以通过拖拽图形完成展示的视图内容，如编写PPT一样便捷高效。引以为傲的数据表格功能可以根据用户实际需求进行多维度的过滤展现，关键数据指标一目了然，便于快速分析定位问题。</p>
              </div>
            </div>
            <div class="c-d-f c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/log4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">应用代理前后端数据整合</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">通过对接设备日志以及前后端流量，网络映射关系可精确到Session级别的数据缝合，无论应用代理前后端做了NAT还是PAT，都可以快速的把前后端每个链接对应起来结合数据快速定位故障点，提升可视化能力，解决网络映射引起的管理盲点。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">网络流量</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">MonitorWay网络流量分析平台系统，通过自动采集网络中传输的数据包，提炼加工出网络和应用性能类的指标数据。
            不仅具备数据回溯、定位故障、告警、分析报告等基础NPM功能；同时支持主动拨测、接入日志类数据并实现数据关联。以数据库的方式存储各类统计数据，提供灵活的数据消费手段。
            内置可自定义配置的Dashboard、简单灵活的数据表格、以及开放的数据对接功能，能够将MonitorWay网络流量分析平台中的任何指标或事件通过内置的消息队列功能传输到第三方平台，
            配合开放的Restful API为第三方提供数据，实现为用户量身定做的大数据自服务平台。从而做到降低运维复杂度，提升业务系统可靠性。</p>
          <img src="../../assets/monitor/network.svg" preview="monitor-virtual1"/>
        </section>
        <!-- <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 虚拟化监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>快速发现虚拟机资产</li>
              <li>智能的优化服务器性能和部署的建议</li>
              <li>使用实时仪表板轻松确定性能、容量和配置问题并进行故障排除</li>
              <li>使用基准阈值对群集、主机、虚拟机和数据存储中的性能差异进行报警</li>
            </ul>
          </div>
        </section> -->
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/network1.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">多源数据整合</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">支持网络流量、设备日志、应用日志、NetFlow、NetStream、sFlow数据的接入处理，为智能分析、应用画像提供丰富的元数据。也可以对接CMDB，应用性能管理（APM），自动化等运维管理平台，搭建运维数据中台。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/network2.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">故障快速定位</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">结合多种AI算法计算出的智能基线结合智能分析产品可以快速的进行故障的根因诊断，评估流量趋势、确定性能瓶颈。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/network3.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">灵活的自定义配置界面</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">除了内置的上百种大屏视图，也可以通过拖拽图形完成展示的视图内容，如编写PPT一样便捷高效。引以为傲的数据表格功能可以根据用户实际需求进行多维度的过滤展现，关键数据指标一目了然，便于快速分析定位问题。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/log4.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">应用代理前后端数据整合</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">通过对接设备日志以及前后端流量，网络映射关系可精确到Session级别的数据缝合，无论应用代理前后端做了NAT还是PAT，都可以快速的把前后端每个链接对应起来结合数据快速定位故障点，提升可视化能力，解决网络映射引起的管理盲点。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'virtual',
  data () {
    return {
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination1',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss">
.p-networkmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -90px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
        .features-special {
          width: 100%;
          img {
            width: 6%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 40px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243;
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 15px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
}
</style>
